import { createApiInstance } from '@/utilities/api/create-instance';
import { InstanceType } from '@/utilities/api/enums/instance-type.enum';

export const enterpriseApi = createApiInstance(InstanceType.Enterprise);
